
class DataItem {
  key: String;
  label: String;
  disabled: boolean;

  constructor(key = "", label = "") {
    this.key = key;
    this.label = label;
  }
}
import UserAssignment from "@/store/modules/system/userassignment/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins} from "@/lib";
import { defineLocale } from "moment";
@Component({
})
export default class ReturnUserAssignment extends Mixins(FormModalMixins) {
    
    model: UserAssignment = new UserAssignment();
    modalData: any = {
    customerIds: Array<DataItem>(),
    acceptUserCustomerIds:Array<DataItem>(),
  };
    async created(){
        Object.assign(this.config, { modelTitleL: "app.UserAssignment.Return",labelWidth:100,okAction:"system/userassignment/return"});
    }
    methods(){
        // (this.$refs["form-modal"] as any).resetFields();
    }
    get userList() {
    return this.$store.state.system.userassignment.userList;
    }
    get customerList() {
    return this.$store.state.system.userassignment.customerList;
  }
  onChange(newTargetKeys,direction, moveKeys) {
     this.model.acceptUserCustomers=newTargetKeys;
      this.model.customerIdList=newTargetKeys;
  }
  get record() {
    return this.$store.state.system.userassignment.editUserAssignment;
  }
      
  selectChange(sourceSelectedKeys, targetSelectedKeys) {
            (this.$refs["return"] as any).leftCheckedKeys=[]
          }
    
}
